/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { INurse } from 'app/shared/model/nurse.model';
import { LeaveType } from 'app/shared/model/enumerations/leave-type.model';

export interface IDayOff {
  id?: string;
  requestedDate?: dayjs.Dayjs | null;
  type?: keyof typeof LeaveType | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdate?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  nurse?: INurse | null;
}

export const defaultValue: Readonly<IDayOff> = {
  active: false,
};
